import { api } from "../AxiosInstance";
import { JobOrder, JobBreakUpDetail } from "../interfaces/job.interface";
import { Driver } from "../interfaces/driver.interface";
import JobService from "./JobService";
import DriverService from "./DriverService";

export function body(response: any): any {
  if (response?.data?.error) throw new Error(response.data.message || "Request failed");
  return response?.data?.data ?? response?.data;
}
export function awaitingPickup(trip: JobBreakUpDetail): boolean {
  return ["INITIATED", "STARTED"].includes(trip.tripStatus) && !trip.startDate
    && !["CANCELLED", "REJECTED", "DELETED", "EDITED", "COMPLETED", "CLOSED", "FORCE_CLOSED"].includes(trip.jobStatus || "");
}
export function assignableJob(job: JobOrder): boolean {
  return job.availableToDrivers === true && job.adminAssignJobsToDriver === true
    && !["COMPLETED", "CANCELLED", "REJECTED", "DELETED", "EDITED", "CLOSED", "FORCE_CLOSED"].includes(job.jobStatus);
}
export function pendingTrips(job: JobOrder): JobBreakUpDetail[] {
  return job.jobBreakups.flatMap(b => b.jobBreakUpDetails).filter(awaitingPickup);
}
export interface AssignmentRequest {
  tripIds: number[]; driverId: number; reassign: boolean; reason?: string;
  pdpOverrideAcknowledged: boolean; pdpOverrideReason?: string;
}
const JobAssignmentService = {
  enabled: async (signal?: AbortSignal): Promise<boolean> => body(await api.get("/settings/job-assignment", { signal })).adminAssignJobsToDriver === true,
  job: async (id: number): Promise<JobOrder> => body(await JobService.getJobDetails(id)),
  jobs: async (page: number, signal?: AbortSignal): Promise<{jobs: JobOrder[]; more: boolean}> => {
    const data = body(await api.get("/job", { params: { skip: page * 30, limit: 30 }, signal }));
    const rows: JobOrder[] = data.content || [];
    return { jobs: rows.filter(assignableJob), more: data.page?.totalElements != null
      ? (page + 1) * 30 < data.page.totalElements : rows.length === 30 };
  },
  drivers: async (user: any, signal: AbortSignal): Promise<Driver[]> => {
    const rows: Driver[] = []; const seen = new Set<number>();
    for (let skip = 0; ; skip += 100) {
      const data = body(await DriverService.getDriversRBAC(user, {status: "ACTIVE", skip, limit: 100, signal}));
      const page: Driver[] = data.content || [];
      if (page.some(d => d.id != null && seen.has(d.id))) throw new Error("Driver pagination could not be completed. Please retry.");
      page.forEach(d => { if (d.id != null) seen.add(d.id); }); rows.push(...page);
      if (!page.length || (data.page?.totalElements != null ? rows.length >= data.page.totalElements : page.length < 100)) return rows;
    }
  },
  assign: async (request: AssignmentRequest) => body(await api.post("/trip/assignments", request)),
};
export default JobAssignmentService;
